import React from 'react';
import styles from "../../styles/Spreadsheet/Spreadsheet.module.css";
import { CheckIcon } from '../../../public/icons';

// interface TableFooterProps {
//   totalAmount: number;
//   money?: string;
//   label?: string;
// }m { selectedDocs, allDocs, totalAmount }

 export  const SpreadsheetFooter = (props: SpreadsheetFooterProps) => {
  if (!props.allDocs || props.allDocs.length === 0) return null;

  const selectedCount = Object.values(props.selectedDocs || {}).filter(Boolean).length;

  return (
    <tfoot className={styles.stickyFooter}>
      <tr>
        <td>
          {selectedCount > 0 && (
            <div className={styles.firstBox}>
              <CheckIcon color="var(--disabled-btn-bg)" />
              <small>{selectedCount}</small>
            </div>
          )}
        </td>
        <td colSpan={3}></td>
        <td className={styles.footerAmount}>
          {props.totalAmount ? 
            new Intl.NumberFormat("uk-UA", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(props.totalAmount)
            : null
            }
        </td>
        <td colSpan={4}></td>
      </tr>
    </tfoot>
  );
};



export const SpreadsheetMobileFooter = (props: SpreadsheetFooterProps) => {
  if (!props.allDocs || props.allDocs.length === 0) return null;

  const selectedCount = Object.values(props.selectedDocs || {}).filter(Boolean).length;

  return (
    <div className={styles.stickyFooterMobile}>
          {selectedCount > 0 && (
            <div className={styles.firstBox}>
              <CheckIcon color="var(--disabled-btn-bg)"/>
              <small>{selectedCount}</small>
            </div>
          )}

        <div className={styles.footerAmount}>
          {props.totalAmount ? 
            new Intl.NumberFormat("uk-UA", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(props.totalAmount)
            : null
            }
        </div>
    </div>

  );
};

